<template lang="pug">
    r-table(
        no-data-text='Sin nota de debitos.'
        no-remove
        no-search
        ref='table'
        remind-key='purchase-debit-note-list'
        v-bind='tableProps' 
        @detail='submitDetail' 
        @remove='submitRemove' 
    )
</template>

<script>
    //
    import { mapActions, mapState } from 'vuex'
    import { RTable } from '@/components/reusable_components/next'
    //
    import PurchaseDebitNoteModel from '@/models/Purchase/PchPurchaseDebitNote'
    import PurchaseDebitNoteFilters from '@/views/Purchase/PchPurchaseDebitNote/PchPurchaseDebitNoteFilters'
    import PurchaseDebitNoteHeaders from '@/views/Purchase/PchPurchaseDebitNote/PchPurchaseDebitNoteHeaders'
    //
    import TranslatorService from '@/services/translator'
    //
    export default {
        name: 'purchase-debit-note-create',
        components: {
            RTable,
        },
        computed: {

            /**
             *
             */
            ...mapState('SnackbarModalModule', [
                'responseConfirm',
            ]),

            /**
             *
             */
            tableProps() {
                return {
                    filters: PurchaseDebitNoteFilters,
                    headers: PurchaseDebitNoteHeaders,
                    service: PurchaseDebitNoteModel,
                }
            },
        },
        methods: {

            /**
             *
             */
            ...mapActions('MenuesModule', [
                'setItemsTopBar',
                'setTitleTopBar',
            ]),

            /**
             *
             */
            ...mapActions('SnackbarModalModule', [
                'setErrorSnackbar',
                'setSuccessSnackbar',
                'setWarningSnackbar',
            ]),

            /**
             * 
             */
            error(error) {
                this.setErrorSnackbar(TranslatorService(PurchaseDebitNoteModel, error.response.data))
            },

            /**
             * 
             */
            refresh() {
                this.$refs.table.refresh()
            },

            /**
             * 
             */
            submitCreate() {
                this.$router.push({ name: 'purchase-debit-note-create' })
            },

            /**
             * 
             */
            submitDetail(event) {
                this.$router.push({ 
                    name: 'purchase-debit-note-update', 
                    params: { 
                        id: event.item.id
                    }
                })
            },

            /**
             * 
             */
            submitRemove(event) {

                //
                this.setWarningSnackbar({
                    title: '¿Esta seguro en eliminar la nota de debito seleccionada?',
                    message: 'Una vez eliminada no se puede recuperar.',
                    confirm: 'eliminar',
                })

                //
                this.selected = event.item
            },

            /**
             * 
             */
            successRemove() {
                this.setSuccessSnackbar('Nota de debito eliminada exitosamente.')
            },

            /**
             * 
             */
            toRemove() {
                this.selected
                    .delete()
                    .then(this.successRemove)
                    .then(this.refresh)
                    .catch(this.error)
            }
        },
        watch: {

            /**
             * 
             */
            responseConfirm(val) {
                switch(val) {
                    case 'eliminar': return this.toRemove()
                }
            }
        },
        mounted() {
            this.setTitleTopBar('Notas de debito')
            this.setItemsTopBar([
                {
                    text: 'agregar nota de debito',
                    icon: 'add_circle',
                    action: this.submitCreate,
                }
            ])
        },
        beforeRouteEnter(to, from, next) {
            next(ctx => {
                //if (!ctx.$can('VIEW_ALL_HOLIDAY')) ctx.$router.push('/')
            })
        },
    }
</script>
